export default __webpack_public_path__ + "static/media/vu.d38aec0a.svg";